import React from 'react'
import { useSelector } from 'react-redux';

import { AddCommentForm } from '../pages'
import { ROLES } from '../../constants'

import BankWrapper from '../layout/BankWrapper'
import NotapWrapper from '../layout/NotapWrapper'
import TransfereeWrapper from '../layout/TransfereeWrapper'

export default function CertificateWrapper({children}) {
    const { userData: {user_role} } = useSelector((state) => state.authData)
    const { certificateManagement:{showCommentFormNotap, showCommentForm, showCommentFormTrans} } = useSelector((state) => state.app)

  return (
    <>
        {user_role === ROLES.BANK.TEXT && (
            <BankWrapper pageTitle='Confirmation Of Reasonableness Module'>
                {children}
                {showCommentForm && <AddCommentForm backdrop={showCommentForm}/> }
            </BankWrapper>
        )}
         
        {user_role === ROLES.TRANSFEREE.TEXT && (
            <TransfereeWrapper pageTitle={'Confirmation Of Reasonableness Module'}>
                {children}
                {showCommentFormTrans && <AddCommentForm backdrop={showCommentFormTrans}/> }
            </TransfereeWrapper>
        )}

        {[ROLES.TRANSFEREE.TEXT, ROLES.BANK.TEXT].includes(user_role) ? null : (
            <NotapWrapper pageTitle={'Confirmation Of Reasonableness Module'}>
                {children}
                {showCommentFormNotap && <AddCommentForm backdrop={showCommentFormNotap}/> }
            </NotapWrapper>
        )}
    </>
  )
}
